module.exports = __webpack_public_path__ + "img/down_guide.7456b6aa.png";